// FAQs
const FaqList = () => import('@/components/faqs/FaqList.vue')
const FaqForm = () => import('@/views/faqs/FaqForm.vue')
const FaqView = () => import('@/views/faqs/FaqView.vue')

/**
 * FAQ routes configuration
 * All routes require authentication
 */
export const faqRoutes = [
  {
    path: '/faqs',
    name: 'Faqs',
    component: FaqList,
    meta: {
      requireAuth: true,
      title: 'FAQs'
    }
  },
  {
    path: '/faqs/new',
    name: 'NewFaq',
    component: FaqForm,
    meta: {
      requireAuth: true,
      title: 'New FAQ'
    }
  },
  {
    path: '/faqs/:id',
    name: 'ViewFaq',
    component: FaqView,
    meta: {
      requireAuth: true,
      title: 'View FAQ'
    }
  },
  {
    path: '/faqs/:id/edit',
    name: 'EditFaq',
    component: FaqForm,
    meta: {
      requireAuth: true,
      title: 'Edit FAQ'
    }
  }
]
